import { createContext } from "react";
import { ISecurityProfile } from "../../types/auth";

export const user: ISecurityProfile = {
    userId: '',
    displayName: '',
    firstName: '',
    lastName: '',
    email: '',
    roles: [],
    orgScopes: []
};

export const AuthContext = createContext<ISecurityProfile>(user);
